import { VacancyTopPictureProps } from "storyblok/components";
import Image from "next/image";

import { Wrapper } from "./VacancyTopPicture.styled";

import { optimizeImage } from "helpers/util/optimizeImage";

export function VacancyTopPicture({
    picture,
    reverse
}: VacancyTopPictureProps) {
    return (
        <Wrapper reverse={reverse}>
            <Image
                priority
                alt={picture.alt ?? "picture"}
                src={optimizeImage(picture.filename, picture.focus, true)}
                draggable={false}
                style={{ objectFit: "cover" }}
                fill
                sizes="(max-width: 768px) 400px, (max-width: 984px) 650px, (min-width: 984px) 900px"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                fetchPriority="high"
            />
        </Wrapper>
    );
}
